module.exports = __webpack_public_path__ + "static/media/策略师.3160beca.png";